import httpClient from './index';

const END_POINT = 'project';

const getProjects = data => httpClient.get(`${END_POINT}`, { params: data });

export { getProjects };
